export default __webpack_public_path__ + "static/media/loupe-small-icon.101dc41e.svg";